// extracted by mini-css-extract-plugin
module.exports = {"backMenu":"back_backMenu__Ay4Dj","link":"back_link__SNLHT"};